var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderAdd = function SvgFolderAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M10.05 14.375a.63.63 0 0 1-.624-.625V9.583a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v4.167a.63.63 0 0 1-.625.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M12.083 12.292H7.916a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.167a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M14.166 18.958H5.833c-3.675 0-4.792-1.116-4.792-4.791V5.833c0-3.675 1.117-4.791 4.792-4.791h1.25c1.458 0 1.916.475 2.5 1.25l1.25 1.666c.275.367.316.417.833.417h2.5c3.675 0 4.792 1.117 4.792 4.792v5c0 3.675-1.117 4.791-4.792 4.791M5.833 2.292c-2.975 0-3.542.566-3.542 3.541v8.334c0 2.975.567 3.541 3.542 3.541h8.333c2.975 0 3.542-.566 3.542-3.541v-5c0-2.975-.567-3.542-3.542-3.542h-2.5c-1.067 0-1.417-.367-1.833-.917l-1.25-1.666c-.434-.575-.559-.75-1.5-.75z"
  })));
};
export default SvgFolderAdd;